import {css} from '@emotion/css';
import {useMemo} from 'react';

import {useWolfTheme} from '@br/mg-components';

const useStyles = () => {
    const theme = useWolfTheme();
    return useMemo(
        () => ({
            wrapper: css({
                position: 'relative',
            }),
            notificationCenter: css({
                position: 'absolute',
                marginTop: theme.orbitalFour,
                border: `1px solid ${theme.palette.stroke.default}`,
                borderRadius: theme.borderRadius,
                right: 0,
            }),
        }),
        [theme.borderRadius, theme.orbitalFour, theme.palette.stroke.default]
    );
};

export default useStyles;
